import React, { useEffect, useState, useCallback } from "react";
import "./InternalPages/Landing.css";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import loaderGif from "../assets/Grid.png";
import { basicauthblog } from "./basicauth";

function DiscoverBlogs() {
  const fromTag = sessionStorage.getItem("FromTag");
  const tagSlug = sessionStorage.getItem("tag");
  const [cards, setCards] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const blogsPerPage = 8;
  const [searchTerm, setSearchTerm] = useState("");
const { password, username } = basicauthblog;
  const base64Credentials = btoa(`${username}:${password}`);
  const Getproductblogs = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `https://blogapi.packky.com/api/bumppy/GetAllProductBlog`,
        {
          method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },

          body: JSON.stringify({ webid: "6" }),
        }
      );
      const data = await response.json();
      if (data.status === "0") {
        const sortedData = [...data.data].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setCards(sortedData);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const GetBlogByHashtags = async (tagSlug) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `https://blogapi.packky.com/api/bumppy/GetBlogByHashtags`,
        {
          method: "POST",
       headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ hashtag: tagSlug, webid: "6" }),
        }
      );
      const data = await response.json();
      if (data.status === "0") {
        const sortedData = [...data.data].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setCards(sortedData);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      if (sessionStorage.getItem("FromTag") === "1") {
        const tagSlug = JSON.parse(sessionStorage.getItem("tag"));
        await GetBlogByHashtags(tagSlug);
        sessionStorage.removeItem("FromTag");
      } else {
        await Getproductblogs();
      }
    };

    fetchData();

    return () => controller.abort();
  }, []);

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const filteredBlogs = cards.filter((item) => {
    const lowerSearch = searchTerm.toLowerCase();
    return (
      item.title.toLowerCase().includes(lowerSearch) ||
      item.excerpt.toLowerCase().includes(lowerSearch) ||
      item.author_name.toLowerCase().includes(lowerSearch)
    );
  });

  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <section className="mb-5 p-3" style={{background: '#ececec'}}>
        <div className=" bg-white p-5" style={{margin: '5rem', borderRadius: '5%'}}>
            <h2 className="text-start">Discover Our Blogs </h2>
            <p className="text-muted">Insights to power your business logistics</p>
            {isLoading && (
                <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                }}
                >
                <img src={loaderGif} alt="Loading..." style={{ width: "" }} />
                </div>
            )}
            <div className="m-0 d-flex overflow-scroll">
                {currentBlogs.map((item, i) => (
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 p-1" key={i}>
                        <div
                            className="My-Landing-card"
                            style={{
                            backgroundColor: "#fff",
                            display: "flex",
                            flexDirection: "column",
                            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                            height: "100%",
                            transition: "opacity 0.5s ease-in-out",
                            borderRadius: "1rem",
                            }}
                        >
                            <img
                            src={
                                item.image_url ||
                                "https://via.placeholder.com/300x200?text=No+Image"
                            }
                            alt={item.image_alt || item.title}
                            title={item.image_title || ""}
                            style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "contain",
                                borderTopRightRadius: "1rem",
                                borderTopLeftRadius: "1rem",
                            }}
                            />
                            <div
                            className="card-content"
                            style={{ padding: "0 10px", overflow: "hidden" }}
                            >
                            <div className="row p-0 m-0 mt-3">
                                <div className="col-2 p-0">
                                <img
                                    src={item.author_image || ""}
                                    alt={item.author_name}
                                    className="rounded-circle"
                                    style={{
                                    width: "2rem",
                                    height: "2rem",
                                    objectFit: "cover",
                                    }}
                                />
                                </div>
                                <div className="col d-flex align-items-center p-0">
                                <p
                                    className="mx-2 mb-1"
                                    style={{
                                    color: "#6d6d6d",
                                    fontSize: ".9rem",
                                    fontWeight: "600",
                                    }}
                                >
                                    {item.author_name}
                                </p>
                                </div>
                            </div>
                            <h6
                                className="mt-1"
                                style={{
                                color: "#3E3232",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 1,
                                overflow: "hidden",
                                display: "-webkit-box",
                                textOverflow: "ellipsis",
                                fontSize: "1rem",
                                }}
                            >
                                {item.title}
                            </h6>
                            <p
                                className="mb-2"
                                style={{
                                color: "#3E3232",
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 4,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontSize: ".9rem",
                                }}
                            >
                                {item.excerpt}
                            </p>
                            <div className="row m-0 p-0">
                                <div className="col  p-0 d-flex justify-content-end">
                                <Link
                                    to={`/blog/${item.slug}`}
                                    onClick={() => {
                                    sessionStorage.setItem("Slug", JSON.stringify(item));
                                    }}
                                    style={{ textDecoration: "none" }}
                                >
                                    Read More -
                                </Link>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                ))}

              
            </div>

        </div>
      
    </section>
  );
}

export default DiscoverBlogs;